import a from"./to-integer-or-infinity.js";var e=a,i=Math.max,o=Math.min,m=function(n,t){var r=e(n);return r<0?i(r+t,0):o(r,t)};export{m as default};
